import type { Shared } from '@studio/types';
import { isAIEnriching } from '../isAIEnriching';

const isAnyMediaAIEnriching = (items: Shared.Library.BaseMediaItem[]): boolean => {
  return items.some((media) => isAIEnriching(media));
};

export default isAnyMediaAIEnriching;
